import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, browserHistory } from 'react-router';

const LinkButton = ({ children, className, to, href, onClick }) => (
  <button
    className={className}
    onClick={event => {
      onClick?.(event);
      if (to) {
        browserHistory.push(to);
      } else if (href) {
        // eslint-disable-next-line no-restricted-globals
        location.href = href;
      }
    }}
  >
    {children}
  </button>
);

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  to: PropTypes.string,
  href: PropTypes.string,
};

export default withRouter(LinkButton);
